
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.ais-facet--header').forEach(header => {
    header.addEventListener('click', () => {
      const content = header.nextElementSibling;
      header.classList.toggle('is-active');
      content.classList.toggle('active');
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const desktopPlaceholder = "Search for products by SKU, name, etc.";
  const mobilePlaceholder = "Search for products by SKU, name, etc.";

  function updatePlaceholders() {
    // 🖥️ Desktop Search Input
    const desktopInput = document.querySelector(".aa-Input");
    if (desktopInput && desktopInput.placeholder !== desktopPlaceholder) {
      desktopInput.placeholder = desktopPlaceholder;
    }

    // 📱 Mobile Detached Button Placeholder
    const mobilePlaceholderEl = document.querySelector(".aa-DetachedSearchButtonPlaceholder");
    if (mobilePlaceholderEl && mobilePlaceholderEl.textContent.trim() !== mobilePlaceholder) {
      mobilePlaceholderEl.textContent = mobilePlaceholder;
    }
  }

  // Run frequently at first — Algolia initializes asynchronously
  const interval = setInterval(updatePlaceholders, 300);

  // Stop polling after 10 seconds
  setTimeout(() => clearInterval(interval), 10000);

  // Observe DOM for dynamic re-renders (Algolia does this on open/close)
  const observer = new MutationObserver(updatePlaceholders);
  observer.observe(document.body, { childList: true, subtree: true });
});
